import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import styles from './Planning.module.css';
import "./FullCalendarReset.css";
import PlanningLegend from "./PlanningLegend";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import frLocale from '@fullcalendar/core/locales/fr';
import {useModal} from "../../contexts/ModalContext";
import DateService from "../../services/DateService";

const Planning = (props) => {
    const { onDatesChange } = props;
    const { showModal, hideModal } = useModal();
    const navigate = useNavigate();
    const {handleEventClick} = props ?? null;

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const events = props.events || [];

    function renderEventContent(eventInfo) {
        let className = styles[eventInfo.event.extendedProps.planningLegend] ?? "";

        className += " " + styles.planningEvent + " " + styles.planningDay;

        let myStyle = eventInfo.event.extendedProps.style;

        if (eventInfo.event.extendedProps.allowedToRegister === false) {
            myStyle = {
                backgroundColor: "#da310b"
            };
        }

        return (
            <div className={className} style={myStyle}>
                <span className={styles.eventDay}>{DateService.getDayOfMonth(eventInfo.event.start)}</span>
            </div>
        );
    }

    const renderDayCellContent = (args) => {
        return { html: `<div class="${styles.planningDay}">${DateService.getDayOfMonth(args.date)}</div>` };
    };

    const handleEventClickDefault = (clickInfo) => {
        if (clickInfo.event.extendedProps.allowedToRegister === false) {
            handleError("Vous ne pouvez pas encore vous inscrire à cette séance :(");
            return;
        }

        clickInfo.jsEvent.preventDefault();
        const eventDate = new Date(clickInfo.event.start);
        const link = clickInfo.event.extendedProps.link;

        const eventsCount = countEventsOnDay(eventDate);

        if (eventsCount > 1) {
            navigate(`/seances/date/${DateService.formatDateWithoutTime(eventDate)}`);
        } else if (link) {
            window.location.href = link;
        } else {
            handleError("Oups ! on dirait qu'il y a une erreur :) ");
        }
    };

    const handleTitleClick = () => {
        navigate('/planning');
    };

    const countEventsOnDay = (date) => {
        return events.filter(event => DateService.sameDay(event.startDate, date)).length;
    };

    const handleDatesSet = (info) => {
        const start = DateService.formatDateWithoutTime(info.startStr);
        const end = DateService.formatDateWithoutTime(info.endStr);

        if (onDatesChange) {
            onDatesChange(start, end);
        }
    };

    return (
        <div className={styles.planningContainer}>
            <div className={styles.planning}>
                <FullCalendar
                    customButtons={{
                        "titleLink": {
                            text: "->",
                            click: handleTitleClick
                        }
                    }}
                    locale={frLocale}
                    firstDay={1}
                    plugins={[dayGridPlugin]}
                    initialView="dayGridMonth"
                    weekends={true}
                    titleFormat={{ year: 'numeric', month: 'long' }}
                    dayHeaderFormat={{ weekday: 'short' }}
                    headerToolbar={{
                        left: 'prev',
                        center: 'title',
                        right: 'next',
                    }}
                    events={events}
                    eventContent={renderEventContent}
                    eventClick={handleEventClick || handleEventClickDefault}
                    dayCellContent={renderDayCellContent}
                    // height={props.height}
                    contentHeight={"auto"}
                    showNonCurrentDates={false}
                    datesSet={handleDatesSet}
                />
            </div>

            <PlanningLegend legend={props.legend}/>
        </div>
    );
}

export default Planning;
